import {
  DiscountText,
  Wrap,
} from "Components/DiscountMessage/discountMessageStyled";

import { TotalPriceValue } from "Components/DiscountMessage/TotalPriceValue";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { NeedName } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { sum } from "Utils/arrayUtils";
import { FormikProps } from "formik";
import React from "react";
import { getTitle } from "../../AkaAdviceMessages/adviceIntroMessagesUtils";
import { usePriceFromAkaAdvice } from "../hooks/usePriceFromAkaAdvice";
import { AkaAdvicePriceFormValues } from "../interfaces";
import { getSelectedPrices } from "./utils";

interface Props {
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  needName: NeedName;
  priceIsLoading: boolean;
}

export const CardTotalPrice = ({
  formProps,
  needName,
  priceIsLoading,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const prices = usePriceFromAkaAdvice(needName);
  const selectedPrices = getSelectedPrices(
    isAdvisor,
    needName,
    formProps,
    prices,
  );
  const totalPrice = selectedPrices.reduce(sum, 0);

  return (
    <Wrap className="discount-message">
      <DiscountText>{getTitle(needName)}</DiscountText>
      <TotalPriceValue
        totalPriceValue={totalPrice}
        isLoading={priceIsLoading}
      />
    </Wrap>
  );
};
